import { TipoEmpresa } from './tipo-empresa';
import { CategoriaEmpresa } from './categoria-empresa';

export class CategoriasContabeisEmpresas {

	id: number;
	idEmpresa: number;
	idCategoria: number;
	
}

